// The mobile app soft-deletes content: fields, reviews, and photos carry
// deleted: true instead of being removed. Legacy reviews also store -1
// (and sometimes 0) for "no rating given". Every reader on the web must go
// through these helpers so deleted content stays hidden and rating math
// only counts real 1-5 ratings.

export const isDeletedField = (field) => field?.deleted === true;

export const activeReviews = (field) => {
    const reviews = Array.isArray(field?.reviews) ? field.reviews : [];
    return reviews.filter(review => review && typeof review === 'object' && review.deleted !== true);
}

export const activePhotos = (field) => {
    const photos = Array.isArray(field?.photos) ? field.photos : [];
    return photos.filter(photo => photo && typeof photo === 'object' && photo.deleted !== true);
}

export const ratingValue = (value) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return undefined;
    }

    const rounded = Math.round(value);
    return rounded >= 1 ? Math.min(5, rounded) : undefined;
}

export const ratingValuesForGroup = (reviews, groupKey) =>
    reviews.map(review => ratingValue(review[groupKey])).filter(value => value !== undefined);

export const averageRatingForGroup = (reviews, groupKey) => {
    const values = ratingValuesForGroup(reviews, groupKey);
    if (values.length === 0) {
        return undefined;
    }

    return values.reduce((a, b) => a + b, 0) / values.length;
}
